// extracted by mini-css-extract-plugin
export default {"otpRow":"OtpInput_otpRow__A37s4","otpBox":"OtpInput_otpBox__-PhOS"};